document.addEventListener('DOMContentLoaded', function () {
  // ✅ Only run on product URLs ( /products/... )
  const path = window.location.pathname || '';
  const isProductPage = path.indexOf('/products/') === 0;

  if (!isProductPage) {
    return; // don't run on home / collections / etc.
  }

  // Adjust selector if needed for your theme
  const imageNodes = document.querySelectorAll(
    '.product-media img, .product__media img'
  );

  const images = Array.from(imageNodes);
  if (!images.length) return;

  const lightbox = document.querySelector('#product-lightbox');
  if (!lightbox) return;

  const lightboxImg = lightbox.querySelector('img');
  const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  const nextBtn = lightbox.querySelector('[data-lightbox-next]');
  const closeBtn = lightbox.querySelector('[data-lightbox-close]');

  let currentIndex = 0;

  // ---- Zoom + drag state ----
  let isDragging = false;
  let dragStartX = 0;
  let dragStartY = 0;
  let imgTranslateX = 0;
  let imgTranslateY = 0;
  let dragMoved = false; // to avoid toggling zoom after a drag

  function updateTransform() {
    if (lightboxImg.classList.contains('zoomed')) {
      lightboxImg.style.transform =
        `translate(${imgTranslateX}px, ${imgTranslateY}px) scale(1.4)`;
    } else {
      imgTranslateX = 0;
      imgTranslateY = 0;
      lightboxImg.style.transform = 'translate(0, 0) scale(1)';
    }
  }

  function openLightbox(index) {
    currentIndex = index;
    const src =
      images[index].getAttribute('data-zoom-src') || images[index].src;

    lightboxImg.src = src;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    lightboxImg.classList.remove('zoomed');
    imgTranslateX = 0;
    imgTranslateY = 0;
    updateTransform();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function showNext() {
    openLightbox((currentIndex + 1) % images.length);
  }

  function showPrev() {
    openLightbox((currentIndex - 1 + images.length) % images.length);
  }

  // Click on product image → open overlay
  images.forEach((img, index) => {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', () => openLightbox(index));
  });

  // Arrows
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);

  // Close
  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  // Zoom on image click (no zoom toggle if we just dragged)
  lightboxImg.addEventListener('click', (e) => {
    if (dragMoved) {
      // ignore click that comes right after a drag
      dragMoved = false;
      return;
    }

    if (lightboxImg.classList.contains('zoomed')) {
      lightboxImg.classList.remove('zoomed');
    } else {
      lightboxImg.classList.add('zoomed');
    }

    updateTransform();
  });

  // ---- Drag-to-pan helpers ----
  function getPoint(e) {
    return e.touches ? e.touches[0] : e;
  }

  function startDrag(e) {
    if (!lightboxImg.classList.contains('zoomed')) return;

    const point = getPoint(e);
    isDragging = true;
    dragMoved = false;
    lightboxImg.classList.add('is-dragging');

    dragStartX = point.clientX - imgTranslateX;
    dragStartY = point.clientY - imgTranslateY;

    e.preventDefault();
  }

  function onDrag(e) {
    if (!isDragging) return;

    const point = getPoint(e);
    imgTranslateX = point.clientX - dragStartX;
    imgTranslateY = point.clientY - dragStartY;
    dragMoved = true;

    updateTransform();
    e.preventDefault();
  }

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    lightboxImg.classList.remove('is-dragging');

    // small delay so the "mouseup" click doesn't toggle zoom
    setTimeout(() => {
      dragMoved = false;
    }, 50);
  }

  // Mouse events
  lightboxImg.addEventListener('mousedown', startDrag);
  window.addEventListener('mousemove', onDrag);
  window.addEventListener('mouseup', endDrag);

  // Touch events (mobile drag)
  lightboxImg.addEventListener('touchstart', startDrag, { passive: false });
  window.addEventListener('touchmove', onDrag, { passive: false });
  window.addEventListener('touchend', endDrag);

  // Keyboard controls
  document.addEventListener('keyup', (e) => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrev();
  });
});
